import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { styled } from "@material-ui/core/styles";
import { Box, Paper, Typography, Grid, Divider } from "@mui/material";
import { alpha } from "@mui/material/styles";
import staticImage1 from "@/assets/staticImage1.svg";
import dontMissChance from "@/assets/dontMissChance.svg";
import claimLotteryPrize from "@/assets/claimLotteryPrice.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3, 2),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(4, 3),
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(5, 4),
    },
  },
  faqContainer: {
    backgroundColor: alpha("#1B1C2D", 0.7),
    borderRadius: theme.spacing(2),
    backdropFilter: "blur(10px)",
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "translateY(-4px)",
    },
  },
  image: {
    maxWidth: "100%",
    height: "auto",
    transition: "transform 0.3s ease",
    filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))",
    "&:hover": {
      transform: "scale(1.05)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "80px",
    },
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(3),
    background: "linear-gradient(45deg, #FFFFFF 30%, #B8B8B8 90%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    [theme.breakpoints.up("sm")]: {
      fontSize: "2rem",
    },
  },
  content: {
    color: "#FFFFFF",
    opacity: 0.8,
    lineHeight: 1.8,
    fontSize: "0.95rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
}));

const StyledImg = styled("img")(({ theme }) => ({
  maxWidth: "100%",
  height: "auto",
  objectFit: "contain",
  transition: "transform 0.3s ease",
  filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))",
  "&:hover": {
    transform: "scale(1.05)",
  },
  [theme.breakpoints.down("sm")]: {
    width: "80px",
  },
  [theme.breakpoints.up("sm")]: {
    width: "100px",
  },
}));

export default function StaticFAQ() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Grid container spacing={3}>
        {/* How does the lottery work? section */}
        <Grid item xs={12}>
          <Box sx={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
            backdropFilter: 'blur(10px)',
            borderRadius: 2,
            p: { xs: 2, sm: 4 },
            transition: 'transform 0.3s ease-in-out',
            '&:hover': {
              transform: 'scale(1.02)'
            }
          }}>
            <Grid container spacing={3} alignItems="flex-start">
              <Grid item xs={12} sm={3} display="flex" justifyContent="center">
                <StyledImg 
                  src={staticImage1} 
                  alt="How it works" 
                  height={150} 
                  width={150} 
                  className={classes.image}
                  style={{
                    filter: 'drop-shadow(0 0 10px rgba(0,0,0,0.2))',
                    transition: 'transform 0.3s ease-in-out'
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={9}>
                <Typography 
                  variant="h4" 
                  sx={{ 
                    mb: 2,
                    background: 'linear-gradient(45deg, #FFD700, #FFA500)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
                  }}
                >
                  How do you play MERV Crypto Fortune?
                </Typography>
                <Box component="ul" sx={{ mt: 2, pl: 0, listStyle: 'none' }}>
                  {[
                    'Choose the lottery you want to play in',
                    'Select the number of tickets you want to buy',
                    'Choose the Power-ball jackpot color on your tickets (optional)',
                    'Set the speed and deceleration of the wheel (optional)',
                    'Click the buy button and pay for the tickets',
                    '10 minutes before the Draw the ticket sale will be closed',
                    'A randomized Smart contract will assign your lucky numbers',
                    'The Spin will always start with the number 000000 or is it 17AQA40QSXD5?',
                    'The 2e Spin will start at the last winning number',
                    'Request a withdrawal to your wallet or get paid out',
                    'View lottery draws in the "Last draw" section'
                  ].map((text, index) => (
                    <Box
                      key={index}
                      component="li"
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        mb: 1.5,
                        '&::before': {
                          content: '""',
                          width: 6,
                          height: 6,
                          borderRadius: '50%',
                          bgcolor: 'primary.main',
                          mr: 2,
                          mt: 1,
                          flexShrink: 0,
                        }
                      }}
                    >
                      {text}
                    </Box>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        {/* How to claim your prize section */}
        <Grid item xs={12}>
          <Box sx={{ 
            background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
            backdropFilter: 'blur(10px)',
            borderRadius: 2,
            p: { xs: 2, sm: 4 },
            transition: 'transform 0.3s ease-in-out',
            '&:hover': {
              transform: 'scale(1.02)'
            }
          }}>
            <Grid container spacing={3} alignItems="flex-start">
              <Grid item xs={12} sm={3} display="flex" justifyContent="center">
                <StyledImg 
                  src={claimLotteryPrize} 
                  alt="Trophy" 
                  height={150} 
                  width={150} 
                  className={classes.image}
                  style={{
                    filter: 'drop-shadow(0 0 10px rgba(0,0,0,0.2))',
                    transition: 'transform 0.3s ease-in-out'
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={9}>
                <Typography 
                  variant="h4" 
                  sx={{ 
                    mb: 2,
                    background: 'linear-gradient(45deg, #FFD700, #FFA500)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
                  }}
                >
                  How to claim your lottery prize?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ 
                    color: "rgba(255, 255, 255, 0.9)",
                    lineHeight: 1.8,
                    fontSize: { xs: '0.9rem', sm: '1rem' },
                    textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
                  }}
                >
                  Congratulations on your win! You'll be automatically redirected to the winners page where you can claim your prize. For prizes greater than $5,000, a KYC (Know Your Customer) verification is required. Once verified, we'll transfer your winnings in cryptocurrency to your player's wallet. From there, you can either:
                </Typography>
                <Box component="ul" sx={{ mt: 2, pl: 0, listStyle: 'none' }}>
                  {[
                    'Request a withdrawal to your preferred wallet',
                    'Get paid out directly to your account',
                    'Keep the funds in your player wallet for future games'
                  ].map((text, index) => (
                    <Box
                      key={index}
                      component="li"
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        mb: 1.5,
                        '&::before': {
                          content: '""',
                          width: 6,
                          height: 6,
                          borderRadius: '50%',
                          bgcolor: 'primary.main',
                          mr: 2,
                          mt: 1,
                          flexShrink: 0,
                        }
                      }}
                    >
                      {text}
                    </Box>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Never miss a lottery draw section */}
        <Grid item xs={12}>
          <Box sx={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
            backdropFilter: 'blur(10px)',
            borderRadius: 2,
            p: { xs: 2, sm: 4 },
            transition: 'transform 0.3s ease-in-out',
            '&:hover': {
              transform: 'scale(1.02)'
            }
          }}>
            <Grid container spacing={3} alignItems="flex-start">
              <Grid item xs={12} sm={3} display="flex" justifyContent="center">
                <StyledImg 
                  src={dontMissChance} 
                  alt="Don't miss chance" 
                  height={150} 
                  width={150}
                  className={classes.image}
                  style={{
                    filter: 'drop-shadow(0 0 10px rgba(0,0,0,0.2))',
                    transition: 'transform 0.3s ease-in-out'
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={9}>
                <Typography 
                  variant="h4" 
                  sx={{ 
                    mb: 2,
                    background: 'linear-gradient(45deg, #FFD700, #FFA500)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
                  }}
                >
                  Never miss a lottery draw
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ 
                    color: "rgba(255, 255, 255, 0.9)",
                    lineHeight: 1.8,
                    fontSize: { xs: '0.9rem', sm: '1rem' },
                    textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
                  }}
                >
                  The excitement of the live draw is an important element of a lottery. Our system is designed so that even if you miss the live draw, you can watch it afterwards as if it were happening live. When you have purchased tickets and want to know if you've won, simply head to the "Last draw" section where you can view every lottery draw as if you're watching it live.
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
